"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDonationMiner = void 0;
const tslib_1 = require("tslib");
const ImpactProvider_1 = require("./ImpactProvider");
const contracts_1 = require("./contracts");
const internalUseTransaction_1 = require("./internalUseTransaction");
const toNumber_1 = require("./toNumber");
const toToken_1 = require("./toToken");
const useCUSDBalance_1 = require("./useCUSDBalance");
const useEpoch_1 = require("./useEpoch");
const useRewards_1 = require("./useRewards");
const react_1 = tslib_1.__importDefault(require("react"));
const useDonationMiner = () => {
    const { provider, signer, address, networkId } = react_1.default.useContext(ImpactProvider_1.ImpactProviderContext);
    const { setEpoch } = react_1.default.useContext(ImpactProvider_1.EpochContext);
    const { setRewards } = react_1.default.useContext(ImpactProvider_1.RewardsContext);
    const { setBalance } = react_1.default.useContext(ImpactProvider_1.CUSDBalanceContext);
    const executeTransaction = (0, internalUseTransaction_1.internalUseTransaction)();
    const approve = async (value, to) => {
        try {
            const { cusd, donationMiner } = (0, contracts_1.getContracts)(provider, networkId);
            const amount = (0, toToken_1.toToken)(value, { EXPONENTIAL_AT: 29 });
            if (to === undefined) {
                to = donationMiner.address;
            }
            if (!address || !(donationMiner === null || donationMiner === void 0 ? void 0 : donationMiner.provider) || !(cusd === null || cusd === void 0 ? void 0 : cusd.provider) || !amount) {
                return;
            }
            const cUSDAllowance = await cusd.allowance(address, to);
            const cusdAllowance = (0, toNumber_1.toNumber)(cUSDAllowance);
            const allowance = cusdAllowance || 0;
            if (allowance >= Number(value)) {
                return { status: true };
            }
            const tx = await cusd.populateTransaction.approve(to, amount);
            return await executeTransaction(tx);
        }
        catch (error) {
            console.log('Error approving amount: \n', error);
            return { status: false };
        }
    };
    const donateToTreasury = async (value) => {
        try {
            if (!signer || !address) {
                return;
            }
            const amount = (0, toToken_1.toToken)(value, { EXPONENTIAL_AT: 29 });
            const { cusd, donationMiner } = (0, contracts_1.getContracts)(provider, networkId);
            const tx = await donationMiner.populateTransaction.donate(cusd.address, amount, address);
            const response = await executeTransaction(tx);
            setEpoch(epoch => (Object.assign(Object.assign({}, epoch), { initialised: false })));
            setRewards(rewards => (Object.assign(Object.assign({}, rewards), { initialised: false })));
            const updatedCUSDBalance = await (0, useCUSDBalance_1.updateCUSDBalance)(provider, networkId, address);
            setBalance(updatedCUSDBalance);
            (0, useRewards_1.updateRewards)(provider, networkId, address).then(updatedRewards => setRewards(rewards => (Object.assign(Object.assign(Object.assign({}, rewards), updatedRewards), { initialised: true }))));
            (0, useEpoch_1.updateEpoch)(provider, networkId, address).then(updatedEpoch => setEpoch(epoch => (Object.assign(Object.assign(Object.assign({}, epoch), updatedEpoch), { initialised: true }))));
            return response;
        }
        catch (error) {
            console.log('Error in donateToTreasury function: \n', error);
        }
    };
    const donateToCommunity = async (community, value) => {
        try {
            if (!signer || !address) {
                return;
            }
            const amount = (0, toToken_1.toToken)(value, { EXPONENTIAL_AT: 29 });
            const { cusd, donationMiner } = (0, contracts_1.getContracts)(provider, networkId);
            const tx = await donationMiner.populateTransaction.donateToCommunity(community, cusd.address, amount, address);
            const response = await executeTransaction(tx);
            setEpoch(epoch => (Object.assign(Object.assign({}, epoch), { initialised: false })));
            setRewards(rewards => (Object.assign(Object.assign({}, rewards), { initialised: false })));
            const updatedCUSDBalance = await (0, useCUSDBalance_1.updateCUSDBalance)(provider, networkId, address);
            setBalance(updatedCUSDBalance);
            (0, useRewards_1.updateRewards)(provider, networkId, address).then(updatedRewards => setRewards(rewards => (Object.assign(Object.assign(Object.assign({}, rewards), updatedRewards), { initialised: true }))));
            (0, useEpoch_1.updateEpoch)(provider, networkId, address).then(updatedEpoch => setEpoch(epoch => (Object.assign(Object.assign(Object.assign({}, epoch), updatedEpoch), { initialised: true }))));
            return response;
        }
        catch (error) {
            console.log('Error in donateToCommunity function: \n', error);
        }
    };
    return {
        approve,
        donateToCommunity,
        donateToTreasury
    };
};
exports.useDonationMiner = useDonationMiner;
//# sourceMappingURL=useDonationMiner.js.map